// test671
(671 && 0);
